import React, { useEffect, useState } from "react";
import Navigation from "../../navigation/Navigation";
import { Grid, CircularProgress, Button } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux';
import StarOutlineIcon from '@material-ui/icons/StarOutline';
// import StarIcon from '@material-ui/icons/Star';
import { updateUsers } from '../../actions/login';
import { getLecturerProjects } from '../../actions/lecturerprojects';
import axios from 'axios';

/**
 * This page presents the user with a list of all suggested projects by lecturers so that they can browse what each project is.
 * If they student likes the sound of a project they can press the shortlist button which will add that project to that users shortlist.
 * If they want to unshortlist they can just press the button shortlist button again.
 * The array of shortlisted projects will be sent to the users collection in the database.
 * @returns a list of all of the suggested projects by lecturers
 */

function ViewProjects() {

    const dispatch = useDispatch();
    const [allUsers, setAllUsers] = useState([]);
    const [user, setUser] = useState({})
    const [id, setID] = useState(null)
    let [shortlisted, setShortlisted] = useState([]);

    useEffect(() => {
        setID(localStorage.getItem("id"))
        setUser(user);
        if(allUsers.length === 0) {
            getAllUsers();
        }
        dispatch(getLecturerProjects());
      }, [dispatch, allUsers, user]);

    const getAllUsers = () => {
        axios.get('https://project-allocation-schedule.herokuapp.com/users').then(function (response) {
        const users = response.data;
        users.forEach((user) => {
            if(user._id === localStorage.getItem("id")) {
                setShortlisted(user.shortlist);
            }
        })
        setAllUsers(response.data);
    })
        .catch(function (error) {
            console.log(error);
        })
        .then(function () {
        });
    }

    const getUser = (id) => {
        let userName = "";
        if(allUsers.length > 0) {
            allUsers.forEach(element => {
                if(element._id === id) {
                    userName = element.firstName + " " + element.secondName
                }
            });
        }
        return userName;
    }

    let projects = []
    const response = useSelector((state) => state.lecturerprojects.data);
    if (response){
        projects = Array.from(response);
    }

    const handleShortlist = (shortlistID) => {
        submitChoices(shortlistID);
    };

    const submitChoices = (shortlist) => {
        const newUser = Object.assign({}, user)
        const newShortlisted = Object.assign([], shortlisted)
        const index = newShortlisted.indexOf(shortlist);
        if (index > -1) {
            newShortlisted.splice(index, 1);
            alert("Project removed from shortlist")
        } else {
            newShortlisted.push(shortlist);
            alert("Project added to shortlist")
        }
        setShortlisted(newShortlisted);
        newUser.shortlist = newShortlisted;
        setUser(newUser)
        if(id) {
            dispatch(updateUsers(id, newUser));
        }
    }

    return(
        <div className="viewProjectsContainer">
            <Navigation/>
            <form id={id}>
            <h1>View Projects</h1>
            {!projects.length ? <CircularProgress /> : (
                <Grid>
                    {projects.map((project) => (
                        <Grid className="paper mt4" key={project._id} item>
                            <p>{project.title}</p>
                            <Button onClick={() => handleShortlist(project._id) }>
                                <StarOutlineIcon/>
                                Shortlist
                            </Button>
                            <p>{getUser(project.userID) || project.userID}</p>
                            <p>{project.description}</p>
                        </Grid>
                    ))}
                </Grid>
            )}
            </form>
        </div>
    )
}

export default ViewProjects